<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
            
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" style="min-height: 60vh;">
                <div class="col-md-12">                   
                    <div class="overflow-auto">
                      <b-table stacked="md" id="my-table" striped small :fields="fields" :items="problemas" responsive="sm" >
                        <template  v-slot:cell(codigo)="data">
                           <span>{{data.item.idProblema}}</span>                                         
                        </template>
                        <template  v-slot:cell(setor)="data">
                           <span>{{data.item.setor.descricao}}</span>                                         
                        </template>
                        <template  v-slot:cell(visualizar)="data">
                            <b-button @click="visualizar(data.item.idProblema)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px"><b-icon icon="search"></b-icon></b-button>                                         
                            <b-button @click="remover(data.item.idProblema)" class="v-button" size="sm" variant="danger"><b-icon icon="trash"></b-icon></b-button>                                                                                  
                        </template>
                      </b-table>
                      <div style="float: right">
                      </div>                      
                    </div>
                </div>
              </b-card>
              <br>
              <b-card bg-variant="light">
                <div class="row" style="float: right">
                    <b-button v-b-modal.modal-problema style="margin-right: 30px; background-color: #303f9f">
                      <b-icon icon="file-earmark"></b-icon>  Novo
                    </b-button>   
                </div>
              </b-card>
        </b-col>
      </b-row>
      <b-modal id="modal-problema" ref="modal" title="Problema" @hidden="resetModal" @ok="salvar" >
                <b-form-group label="Descrição" label-for="name-input"  >
                    <b-input id="name-input" v-model="problema.descricao" ></b-input>
                </b-form-group>
                <b-form-group label="Código - Rotina HelpDesk" label-for="name-input"  >
                    <b-input id="name-input" type="number" v-model="problema.codRotinaHelpDesk" ></b-input>
                </b-form-group>
                <b-form-group label="Setor" label-for="name-input"  >
                    <model-list-select :list="setores"
                        v-model="problema.setor"
                        option-value="idSetor"
                        option-text="descricao"
                        placeholder="Setor">
                    </model-list-select>
                </b-form-group>
                
        </b-modal>  
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import BarraNavegacao from '../../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao, ModelListSelect },

  data(){
    return{
      problemas: [],
      setores: [],
      fields: ['descricao','setor',{ key: 'visualizar', label: 'Visualizar' , class:'text-center'}],
      problema: {idProblema: null, descricao: '', status: 'A', setor: {}, codRotinaHelpDesk: 0}
    }
  },

  created(){
      this.validaAcesso();
  },

  mounted(){
    this.listar();
    this.listarSetores();
  },

  methods: {

    alertaMensager(mensagem,titulo,tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
              }).then(r => {
               r.value;
            });
        },

    resetModal() {
        this.problema= {idProblema: null, descricao: '', status: 'A', setor: {}, codRotinaHelpDesk: 0}
    },

    salvar(){
        this.$http.post('/problema', this.problema).then(res => {
             this.alertaMensager(res.data,"","success");   
             this.listar();      
          })
    },

    listarSetores(){
      this.$http.get("/setor").then(res => {
         this.setores = res.data;
      }) 
    },

    validaAcesso(){
        this.$http.get('/gerencia', this.sala).then()
    },

    listar(){
      this.$http.get("/problema").then(res => {
         this.problemas = res.data;
      }) 
    },

    visualizar(id){
      this.$http.get("/problema/"+id).then(res => {
         this.problema = res.data;
         this.$bvModal.show('modal-problema');
      }) 
    },

    remover(id){
        this.$confirm("Tem certeza que deseja excluir o problema ?").then(() => {
            this.$http.delete("/problema/"+id).then(res => {
                if(res.status == 200){
                    this.alertaMensager("",res.data,"success");
                }else{
                    this.alertaMensager("",res.data,"error");
                }
                
            }) 
        });
      
    }
    
  }
}

</script>

<style>

</style>
